function initProgramFinder() {
	var $        = jQuery,
		campuses = {
			EAU: "UW-Eau Claire",
			EAU_BRN: "UW-Eau Claire - Barron County",
			GBY: "UW-Green Bay",
			MAN: "UW-Green Bay - Manitowoc Campus",
			MNT: "UW-Green Bay - Marinette Campus",
			SHB: "UW-Green Bay - Sheboygan Campus",
			LAC: "UW-La Crosse",
			MSN: "UW-Madison",
			MIL: "UW-Milwaukee",
			OSH: "UW-Oshkosh",
			PKS: "UW-Parkside",
			PLT: "UW-Platteville",
			BRB: "UW-Platteville Baraboo Sauk County",
			RVF: "UW-River Falls",
			STP: "UW-Stevens Point",
			MSF: "UW-Stevens Point at Marshfield",
			MTH: "UW-Stevens Point at Wausau",
			STO: "UW-Stout Polytechnic",
			SUP: "UW-Superior",
			WTW: "UW-Whitewater",
			RCK: "UW-Whitewater at Rock County",
			XPK: "UW-Parkside", //"UW Flexible Option",
			XMI: "UW-Milwaukee"
		},
		programLevels = {
			A: "Associate",
			B: "Bachelor",
			M: "Masters",
			D: "Doctorate",
			P: "Doctorate",
			Y: "Doctorate",
			S: "Education Specialist",
		}

	function isMobileDevice() {
		var coarsePointer = (window.matchMedia('(pointer: coarse)')).matches,
			touchPoints   = 'maxTouchPoints' in navigator && navigator.maxTouchPoints > 0,
			orientation   = 'orientation' in window,
			canHover      = (window.matchMedia('(any-hover: hover)')).matches;

		return coarsePointer && touchPoints && orientation && !canHover;
	}

	function supportsShowPicker() {
		let detectionEnabled   = true,
			selectElem         = document.createElement('select'),
			supportsShowPicker = 'showPicker' in selectElem && typeof selectElem.showPicker == 'function';

		return detectionEnabled && supportsShowPicker;
	}

	$('[data-js="program-finder-ui"]').each(function () {
		var UI             = $(this),
			filters        = UI.find('[data-js="program-filters"]'),
			programs       = [],
			resultTemplate = UI.find('[data-js="result-template"]').html(),
			resultWrapper  = UI.find('[data-js="results-wrapper"]'),
			results        = resultWrapper.find('[data-js="results"]'),
			resultCount    = resultWrapper.find('[data-js="result-count"]'),
			resultsPlural  = resultWrapper.find('[data-js="result-count-plural"]'),
			filterTimeout  = null,
			screenReaderAnnounce = $('#screen-reader-announce');

		function openDropdown(elem) {
			let button, dropdown;

			if (elem.is('button')) {
				button   = elem;
				dropdown = UI.find('#' + button.attr('aria-controls'));
			} else if (elem.closest('.select-dropdown').length > 0) {
				dropdown = elem.closest('.select-dropdown');
				button   = UI.find('[aria-controls="' + dropdown.attr('id') + '"]');
			}

			if (isMobileDevice() && supportsShowPicker()) { //mobile device
				let select = dropdown.next('select');

				//make the real select "visible" so that the browser will allow it to showPicker()
				select.css({
					opacity: 0,
					padding: 0,
					margin: 0,
					height: 0,
					width: 0,
					display: 'block'
				});

				select.get(0).showPicker();
			} else { //'desktop' device
				dropdown.show();

				dropdown.find('> ul').attr('tabindex', '0');
				dropdown.find('li[role="option"]').attr('tabindex', '0');

				button.attr('aria-expanded', 'true');
				button.closest('.select-wrapper').addClass('select-expanded');
			}

			button.trigger('uws-program-finder:dropdown-opened');
		}

		function closeDropdown(elem) {
			let button, dropdown;

			if (elem.is('button')) {
				button   = elem;
				dropdown = UI.find('#' + button.attr('aria-controls'));
			} else if (elem.closest('.select-dropdown').length > 0) {
				dropdown = elem.closest('.select-dropdown');
				button   = UI.find('[aria-controls="' + dropdown.attr('id') + '"]');
			}

			if (isMobileDevice() && supportsShowPicker()) { //mobile device
				let select = dropdown.next('select');

				select.css({
					opacity: '',
					padding: '',
					margin: '',
					height: '',
					width: '',
					display: 'none'
				});
			} else { //'desktop' device
				dropdown.hide();

				dropdown.find('> ul').attr('tabindex', '-1');
				dropdown.find('li[role="option"]').attr('tabindex', '-1');

				button.attr('aria-expanded', 'false');
				button.closest('.select-wrapper').removeClass('select-expanded');

				button.trigger('uws-program-finder:dropdown-closed');
			}
		}

		function closeDropdowns(which) {
			if (!which) {
				which = UI.find('[data-js="dropdown-toggle"][aria-expanded="true"]');
			}

			which.each(function () {
				let button = UI.find(this);

				closeDropdown(button);
			});
		}

		function selectFakeOption(li) {
			let id = li.attr('id') || crypto.randomUUID();

			li.attr('aria-selected', 'true');
			li.attr('id', id);
			li.closest('ul').attr('aria-activedescendent', id);
		}

		function deselectFakeOption(li) {
			let id = li.attr('id') || crypto.randomUUID();

			li.removeAttr('aria-selected');
			li.attr('id', id);
			li.closest('ul').attr('aria-activedescendent', id); //yes, even though we just deactivated it: see multiselect: https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/listbox_role#required_javascript_features
		}

		function selectRealOption(option) {
			let select         = option.closest('select'),
				selectedValues = [];

			option.prop('selected', true);
			option.attr('selected', 'true');
			
			select.find('option:selected').each(function () {
				selectedValues.push($(this).val());
			});
			select.val(selectedValues);

			select.trigger('change', {updateFakeSelect: false});
		}

		function deselectRealOption(option) {
			let select         = option.closest('select'),
				selectedValues = [];

			option.prop('selected', false);
			option.removeAttr('selected');
			
			select.find('option:selected').each(function () {
				selectedValues.push($(this).val());
			});
			select.val(selectedValues);

			select.trigger('change', {updateFakeSelect: false});
		}

		function addAppliedFilter(option) {
			let type, value, label, typeLabel;

			type = option.closest('select[multiple]').attr('name');

			value = option.val();
			label = option.text();
			typeLabel = UI.find('[data-js="dropdown-toggle"][aria-controls="' + option.closest('select[multiple]').prev('.select-dropdown').attr('id') + '"]').text();

			if (UI.find('[data-js="applied-filters"] [data-js="applied-filter"][data-type="' + type + '"][data-value="' + value + '"]').length == 0) {
				UI.find('[data-js="applied-filters"] .af-inner').append(
					'<div class="col-auto" data-js="applied-filter" data-type="' + type + '" data-value="' + value + '">' +
						'<button class="af" id="" aria-label="Remove ' + label + '">' +
							'<span class="filter-type">' + typeLabel + '</span>' +
							'<span class="filter-value">' + label + '</span>' +
						'</button>' +
					'</div>'
				);
			}

			UI.find('[data-js="applied-filters"]:not(:visible)').show();
		}

		function removeAppliedFilter(option) {
			let type, value, label;

			if (option.is('option')) {
				type = option.closest('select[multiple]').attr('name');
				value = option.val();

				UI.find('[data-js="applied-filters"] [data-js="applied-filter"][data-type="' + type + '"][data-value="' + value + '"]').remove();
			}

			if (UI.find('[data-js="applied-filters"] [data-js="applied-filter"]').length < 1) {
				UI.find('[data-js="applied-filters"]').hide();
			}
		}

		function getRealOption(li) {
			let dropdown = li.closest('.select-dropdown'),
				select   = dropdown.next('select'),
				option   = select.find('option[value="' + li.data('value') + '"]');

			return option;
		}

		function getFakeOption(option) {
			let select   = option.closest('select'),
				dropdown = select.prev('.select-dropdown'),
				li       = dropdown.find('li[data-value="' + option.val() + '"]');

			return li;
		}

		function getButton(option_or_li) {
			if (!option_or_li.is('li')) {
				option_or_li = getFakeOption(option_or_li);
			}

			return UI.find('[aria-controls="' + option_or_li.closest('.select-dropdown').attr('id') + '"]');
		}

		function displayResults() {
			let filteredPrograms = [],
				formSerialized   = filters.serializeArray(),
				filterValues     = {};

			//process the serialized form a little
			for (let i = 0; i < formSerialized.length; i++) {
				let filter = formSerialized[i];

				if (filter.name == 'search' && filter.value == '') {
					continue;
				}

				if (!filterValues[filter.name]) {
					filterValues[filter.name] = [];
				}

				if ((filter.name == 'campus' || filter.name == 'level') && filter.value.includes('|')) {
					let values = filter.value.split('|');

					for (let j = 0; j < values.length; j++) {
						filterValues[filter.name].push(values[j]);
					}
				} else {
					filterValues[filter.name].push(filter.value);
				}
			}

			if (Object.keys(filterValues).length > 0) {
				//filter results, then display
				for (let i = 0; i < programs.length; i++) {
					let candidateProgram = programs[i];

					
					if (filterValues.interest) {
						let found = false;

						for (let j = 0; j < filterValues.interest.length; j++) {
							let value = filterValues.interest[j];

							if (candidateProgram.career_clusters.includes(value)) {
								found = true;
								break;
							}
						}

						if (!found) {
							continue;
						}
					}

					
					if (filterValues.campus) {
						let found = false;

						for (let j = 0; j < filterValues.campus.length; j++) {
							let value = filterValues.campus[j];

							if (candidateProgram.campuses.includes(value)) {
								found = true;
								break;
							}
						}

						if (!found) {
							continue;
						}
					}

					if (filterValues.level) {
						let found = false;

						for (let j = 0; j < filterValues.level.length; j++) {
							let value = filterValues.level[j];

							if (candidateProgram.program_level == value) {
								found = true;
								break;
							}
						}

						if (!found) {
							continue;
						}
					}

					if (filterValues.type) {
						let found = false;

						for (let j = 0; j < filterValues.type.length; j++) {
							let value = filterValues.type[j];

							if (value == 'Concentration') {
								if (candidateProgram.submajors.length > 0) {
									found = true;
									break;
								}
							} else if (candidateProgram.program_type == value) {
								found = true;
								break;
							}
						}

						if (!found) {
							continue;
						}
					}

					if (filterValues.delivery) {
						let found = false;

						for (let j = 0; j < filterValues.delivery.length; j++) {
							let value = filterValues.delivery[j];

							if (candidateProgram.course_delivery == value || candidateProgram.course_delivery == 'Online/In-Person') {
								found = true;
								break;
							} else if (Array.isArray(candidateProgram.submajors)) {
								for (let i = 0; i < candidateProgram.submajors.length; i++) {
									let submajor = candidateProgram.submajors[i];

									if (submajor.course_delivery == value || submajor.course_delivery == 'Online/In-Person') {
										found = true;
										break;
									}
								}
							}

							if (found) {
								break;
							}
						}

						if (!found) {
							continue;
						}
					}

					if (filterValues.search) {
						let requireAllWords = false,
							commonWords = ['a', 'an', 'the', 'in', 'on', 'at', 'to', 'for', 'with', 'by', 'of', 'from', 'about', 'through', 'and', 'or', 'but', 'nor', 'yet', 'so', 'i', 'you', 'he', 'she', 'it', 'we', 'they', 'me', 'him', 'her', 'us', 'them', 'is', 'am', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'do', 'does', 'did', 'can', 'could', 'will', 'would', 'shall', 'should', 'may', 'might', 'must', 'not', 'no', 'all', 'any', 'some', 'many', 'few', 'much', 'more', 'less', 'very', 'just', 'only', 'up', 'down', 'out', 'in', 'off', 'on', 'here', 'there', 'when', 'where', 'why', 'how', 'what', 'who', 'which', 'this', 'that', 'these', 'those'],
							searchWords = filterValues.search[0].split(/[^a-zA-Z0-9]/).map(function (word) { return word.toLowerCase(); }),
							tokens = [];

						//filter duplicates
						searchWords = [...new Set(searchWords)];
						//filter common words string
						searchWords = searchWords.filter(function (word) { return !commonWords.includes(word) && word !== ''; });

						tokens = tokens.concat(candidateProgram.title.split(/[^a-zA-Z0-9]/));
						tokens.push(programLevels[candidateProgram.program_level]);
						tokens.push(candidateProgram.course_delivery);

						if (candidateProgram.submajors.length > 0) {
							tokens.push('concentration');

							for (let j = 0; j < candidateProgram.submajors.length; j++) {
								let submajor = candidateProgram.submajors[j];

								tokens = tokens.concat(submajor.title.split(/[^a-zA-Z0-9]/));
							}
						}

						for (let j = 0; j < candidateProgram.campuses.length; j++) {
							let campusCode = candidateProgram.campuses[j];

							if (campuses[campusCode]) {
								tokens = tokens.concat(campuses[campusCode].split(/[^a-zA-Z0-9]/));
							}
						}

						tokens.push(candidateProgram.program_type);

						for (let j = 0; j < candidateProgram.career_clusters.length; j++) {
							tokens = tokens.concat(candidateProgram.career_clusters[j].split(/[^a-zA-Z0-9]/));
						}

						tokens.concat(candidateProgram.keywords.map(function (word) { return word.toLowerCase(); }));

						tokens = tokens.map(function (token) { return token.toLowerCase(); });

						//filter duplicates
						tokens = [...new Set(tokens)];
						//filter empty string
						tokens = tokens.filter(function (token) { return token !== ''; });

						if (requireAllWords) {
							let allFound = true;

							for (let j = 0; j < searchWords.length; j++) {
								let word = searchWords[j],
									wordFound = false;

								for (let k = 0; k < tokens.length; k++) {
									let token = tokens[k];

									if (token == word || token.includes(word)) {
										wordFound = true;
										break;
									}
								}

								if (!wordFound) {
									allFound = false;
									break;
								}
							}

							if (!allFound) {
								continue;
							}
						} else {
							let found = false;

							for (let j = 0; j < searchWords.length; j++) {
								let word = searchWords[j];

								for (let k = 0; k < tokens.length; k++) {
									let token = tokens[k];

									if (token == word || token.includes(word)) {
										found = true;
										break;
									}
								}
							}

							if (!found) {
								continue;
							}
						}
						
					}

					filteredPrograms.push(candidateProgram);
				}
			}

			resultCount.text(filteredPrograms.length);

			if (filteredPrograms.length !== 1) {
				resultsPlural.show();
			} else {
				resultsPlural.hide();
			}

			results.find('[data-js="result"]').remove();

			for (let i = 0; i < filteredPrograms.length; i++) {
				let program = { ...filteredPrograms[i]};

				if (Array.isArray(program.campuses) && program.campuses.length > 0) {
					program.campuses = program.campuses.map(function (campusCode) {
						if (campuses[campusCode]) {
							return campuses[campusCode];
						} else {
							return '';
						}
					});

					program.campuses = program.campuses.filter(function (campus) { return campus !== ''; });

					program.campuses = program.campuses.join(', ');
				}

				if (program.program_level) {
					if (programLevels[program.program_level]) {
						program.program_level = programLevels[program.program_level];
					} else {
						program.program_level = '';
					}
				}

				results.append(ejs.render(resultTemplate, program));
			}

			if (filteredPrograms.length > 0) {
				resultWrapper.show();
			} else {
				resultWrapper.hide();
			}

			screenReaderAnnounce.text('Displaying ' + filteredPrograms.length + ' result' + (filteredPrograms.length !== 1 ? 's' : ''));
		}

		//some programs have n campuses listed (where n > 1), we'd like to display them as if
		//they were created as n separate programs, each with 1 campus
		function splitCampuses(programs) {
			var splitPrograms = [];

			for (let i = 0; i < programs.length; i++) {
				let program = programs[i];

				if (program.campuses.length > 1) {
					for (let j = 0; j < program.campuses.length; j++) {
						let splitProgram = { ...program};

						splitProgram.campuses = [ program.campuses[j] ];

						splitPrograms.push(splitProgram);
					}
				} else {
					splitPrograms.push(program);
				}
			}

			return splitPrograms;
		}

		//show/hide dropdown
		UI.on('click keyup keydown', '[data-js="dropdown-toggle"]', function (e) {

			let button = $(this),
				dropdown = $('#' + button.attr('aria-controls'));

			if ((e.type == 'keyup' || e.type == 'keydown') && (e.which !== 27 && e.which !== 40)) {
				return;
			}

			//close others
			$('[data-js="dropdown-toggle"]').not(button).each(function () {
				let otherButton = $(this);

				closeDropdown(otherButton);
			});

			if (e.type == 'keyup') {
				if (e.which === 27) {
					closeDropdown(button);
				} else if (e.which === 40) {
					openDropdown(button);
				}
			} else if (e.type == 'click') {
				//toggle this one
				if (button.attr('aria-expanded') == 'true') {
					closeDropdown(button);
				} else {
					openDropdown(button);
				}
			}

			//if keyboard "click", focus the dropdown
			if (e.detail === 0) {
				dropdown.find('> ul').focus();
			}

			return false;
		});

		UI.on("click keydown", '[data-js="program-filters"] .select-dropdown li[role="option"]', function (e) {
			let li       = $(this),
				option   = getRealOption(li),
				button   = getButton(li);

			if (e.type == 'keydown' && e.which !== 13) {
				return;
			}

			if (li.is('[aria-selected="true"]')) {
				deselectFakeOption(li);

				deselectRealOption(option);
			} else {
				selectFakeOption(li);

				selectRealOption(option);
			}

			closeDropdown(button);
		});

		//toggle options without ctrl/shift clicking
		UI.on('change', '[data-js="program-filters"] select[multiple]', function (event, args) {

			let select, currentSelections, previousSelections, same, added, removed;

			if (event.ctrlKey || event.metaKey) {
				return;
			}

			select = $(this);
			currentSelections  = new Set(select.val());
			previousSelections = new Set(select.data('previous') || []);

			same = previousSelections.intersection(currentSelections);
			added = currentSelections.difference(same);
			removed = previousSelections.difference(same);

			select.data('previous', select.val());

			added.forEach(function (value) {
				let option = select.find('option[value="' + value + '"]');

				option.trigger('uws-program-finder:filter-added');

				if (!args || (!("updateFakeSelect" in args) || args.updateFakeSelect)) {
					selectFakeOption(getFakeOption(option));
				}

				addAppliedFilter(option);
			});

			removed.forEach(function (value) {
				let option = select.find('option[value="' + value + '"]');
				
				option.trigger('uws-program-finder:filter-removed');

				if (!args || (!("updateFakeSelect" in args) || args.updateFakeSelect)) {
					deselectFakeOption(getFakeOption(option));
				}

				removeAppliedFilter(option);
			});
		});

		//close dropdowns when clicking off them
		$('body').on('click', function (e) {
			let target = $(e.target);

			if (target.closest('[data-js="dropdown-toggle"], .select-dropdown').length == 0) {
				closeDropdowns();
			}
		});

		UI.on('submit', '[data-js="program-filters"]', function () {
			displayResults();
			return false;
		});

		UI.on('click', '[data-js="applied-filters"] [data-js="applied-filter"]', function () {
			let appliedFilter = $(this),
				type = appliedFilter.data('type'),
				value = appliedFilter.data('value'),
				option = UI.find('[data-js="program-filters"] select[multiple][name="' + type + '"] option[value="' + value + '"]');

			deselectRealOption(option);
			deselectFakeOption(getFakeOption(option));
		});

		UI.on('uws-program-finder:filter-added uws-program-finder:filter-removed', function () {
			clearTimeout(filterTimeout);

			displayResults();
		});
		UI.on('keyup', '[data-js="search-input"]', function () {
			clearTimeout(filterTimeout);

			filterTimeout = setTimeout(function () {
				displayResults();
			}, 500);
		});

		$.ajax({
			url: '/wp-json/uws-program-finder/v1/programs',
			success: function (data) {
				programs = data.data;
			}
		});
	});
}

initProgramFinder();